import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostBonusesReferralIssue = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_ISSUE_BONUSES_REFERRALS
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostBonusesReferralIssue as SetPostBonusesReferralIssue
}